import React from "react";

import Page from "../../components/Page/Page";

interface ErrorProps {
  name: string;
  error: string;
}

type TypesOfErrors = {
  [key: string]: string;
};

const Error: React.FC<ErrorProps> = ({
  name,
  error = "graphql" || "network" || "unknown",
}) => {
  return (
    <Page name={name}>
      {/* <Alert content={TypesErrors[error]} variant="error" /> */}
    </Page>
  );
};

export default Error;
